/*
 * @Description: 
 * @Autor: yd
 * @Date: 2020-09-17 15:05:12
 * @LastEditors: yd
 * @LastEditTime: 2020-09-17 15:40:58
 */
// 客户管理
import http from '../httpConfig'

const table = "mrbase_sys_language_values"


// 获取客户国际化列表
export const getClientINTList = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/clientlanguage/list-clientlanguage/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 获取客户国际化详情
export const detailClientINT = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/clientlanguage/find-clientlanguage/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

//修改客户国际化详情
export const updateClientINT = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/clientlanguage/update-clientlanguage/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
